import { WorkflowStage } from '@app/core/models/workflows/workflow-stage';
import { WorkflowModel } from '@app/core/models/workflows/workflow.model';
import { InvoiceModel } from '@app/core/models/invoices/invoice.model';
import { AttachmentModel } from '../attachment.model';
import { InvoiceAssignmentGroupModel } from './invoice-assignment-group.model';
import { InvoiceExpenseDetail } from './invoice-expense.model';
import { InvoiceAmendmentDetail } from './invoice-amendment.model';
import { InvoiceDeductionDetail } from './invoice-deduction.model';
import { InvoiceDelegationDetail } from './invoice-delegation.model';
import { WorkflowPromotionModel } from '../workflowsPromotion/workflow-promotion.model';
import { WorkflowPromotionStage } from '../workflowsPromotion/workflow-stage-promotion';
import { InvoiceFilesForCreate } from './invoice-files-for-create';

export class InvoiceDetailModel extends InvoiceModel {
  public Id: string;

  public Number: string;

  public State: string;

  public PrimaryReference: string;

  public SecondaryReference: string;

  public Ocrdate: Date | string | null;

  public CreationDate: Date | string;

  public IssuedAt: Date | string | null;

  public DueDate?: Date | string | null;

  public EstimatedActDate?: Date | string | null;

  public RecipientEntityId?: number;

  public RecipientEntityName: string;

  public AmountTaxExcludedWithoutAmendment: number | null;

  public AmountTaxExcluded: number | null;

  public AmountTaxIncluded: number | null;

  public Currency: string;

  public IsReverseFactoring: boolean;

  public IsWorkingSituation: boolean;

  public RecyclingFlag: string;

  public RejectionFlag: string;

  public InitialAssignmentGroupId: number | null;

  public InitialAssignmentGroupName: string;

  public InitialAssignmentAt: Date | string | null;

  public CurrentAssignmentGroupId: number | null;

  public CurrentAssignmentGroupName: string;

  public CurrentAssignmentAt: Date | string | null;

  public CurrentControlGroupIdOfAssignmentGroup: number | null;

  public IsProcessed: boolean;

  public ProcessedAt: Date | string | null;

  public ProcessedByUserId: string;

  public ProcessedByUser: string;

  public TypeId: number;

  public TypeName: string;

  public ClientIdPPR: string;

  public GroupIdPPR: string;
  
  public SupplierMdmId: number | null;

  public SupplierSiren: string;

  public SupplierSiret: string;

  public SupplierCompanyName: string;

  public SupplierVatNumber: string;

  public SupplierRcsNumber: string;

  public SupplierAddress: string;

  public SupplierEmail: string;

  public SupplierRecipientName: string;

  public SupplierHasWarning: boolean;

  public RecipientEntity: string;

  public CurrentAssignmentReferent: string;

  public IsVoucherValidated: boolean | null;

  public VoucherValidatedAt: Date | string | null;

  public VoucherValidatedByUserId: string;

  public WorkflowIsCompleted: boolean | null;

  public WorkflowIsActive: boolean | null;

  public Workflow: WorkflowModel;

  public WorkflowPromotion: WorkflowPromotionModel;

  public WorkflowCurrentStage: WorkflowStage;

  public WorkflowPromotionCurrentStage: WorkflowPromotionStage;

  public IsVoucher: boolean;

  public IsPPR: boolean;

  public VoucherDepartment: string;

  public VoucherAnalyticalSection: string;

  public VoucherAnalyticalCode: string;

  public VoucherComment: string;

  public PickedAt: Date | null;

  public PickedByUserId: string;

  public PickedByUser: string;

  public ComplaintAt: Date | null;

  public ComplaintByUserId: string;

  public ComplaintByUser: string;

  public ComplaintComment: string;

  public PrimaryReferenceOnPdf: boolean | null;

  public Attachments: Array<AttachmentModel>;

  public Assignments: Array<InvoiceAssignmentGroupModel>;

  public SupplierEvaluaCompanyName: string;

  public SupplierSageErpCode: string;

  public SupplierEvaluaSIRET: string;

  public SupplierIdFournisseur: number;

  public ThirdPartyPayerName: string;

  public ThirdPartyPayerId: number;

  public IsForPPRDirectInvoiceBDC: boolean = false;

  public CanProcessInvoice: boolean | null;

  public OperationId: string | null;

  public OperationName: string | null;

  public CommandeId: string | null;

  public CommandeInternalNumber: string | null;

  public InvoicePPRType: string;

  public OperationSocieteId: string | null;

  public OperationSocieteName: string | null;

  public OperationAssistantName: string | null;

  public OperationEntiteComptable: string | null;

  public Expenses: Array<InvoiceExpenseDetail>;

  public Amendments: Array<InvoiceAmendmentDetail>;

  public Deductions: Array<InvoiceDeductionDetail>;

  public Delegations: Array<InvoiceDelegationDetail>;

  public AmountTradeExcludingTax: number | null;

  public VatCode: string | null;

  public VatLabel: string | null;

  public VatValue: string | null;

  public MarketId: string | null;

  public TradeId: string | null;

  public TradeLabel: string | null;

  public SituationReference: string | null;

  public SituationPeriode: Date | string | null;

  public IsInvoiceInErrorPPR: boolean | null;

  public SendUpdateToSaga: boolean = true;

  public CalculatedWaitingFlag: boolean = true;

  public CanCancelProcessPromotion: boolean = false;

  public CanManageInvoiceAGI: boolean = false;

  public IsPrescriptorGroup: boolean = false;

  public FileForCreate: InvoiceFilesForCreate;
}
